module.exports = __webpack_public_path__ + "img/spinner_purple_64x64.62cffbd0.gif";